export const None = 0

export const Small = 1

export const Normal = 2

export const Large = 3
